<template>
  <div>
    <label class="fw-normal">
      <input type="checkbox" name="allowMultipleTimes" :checked="value.allowMultipleTimes" class="checkbox_position" @input="checkboxDataChanged('allowMultipleTimes', $event.target.checked)" />
      <span class=""> Allow participants to repeat survey each time it is present</span>
    </label>
    <div>
      <label class="fw-normal">
        <input type="checkbox" name="isActivityOptional" :checked="value.isActivityOptional" class="checkbox_position" @input="checkboxDataChanged('isActivityOptional', $event.target.checked)" />
        <span> Activity is optional and will be excluded from the compliance report</span>
      </label>
    </div>
    <label class="fw-normal" :class="{ 'opacity-change': !value.allowMultipleTimes }">
      <input type="checkbox" name="showDailySummary" :checked="value.showDailySummary" class="checkbox_position" @input="checkboxDataChanged('showDailySummary', $event.target.checked)" :disabled="!value.allowMultipleTimes" />
      <span> Show participants a summary of their daily activity completion at the start of the activity. Available only for repeatable tasks.</span>
    </label>
    <!-- version 2.0.0-rc.11 of bootstrap-vue does not allow multiple modals, so if this modal is inside of another modal, we should not show this other modal-->
    <template v-if="allowModal">
      <div class="view-screen" :class="{ 'opacity-change': !value.allowMultipleTimes }">
        <span v-if="value.allowMultipleTimes" data-toggle="modal" data-target="#screen-modal" class="cursor_pointer">View Daily Activity Completion Screen</span>
        <span v-else>View Daily Activity Completion Screen</span>
      </div>
      <div id="screen-modal" class="modal fade modal-position" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content"><img alt="repeatable-activity-example" src="static/img/repeatable-activity-example.png" /></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * This is a component to handle general checkboxes when scheduling an activity.
 * It should be used when there is a custom or milestone schedule
 */
export default {
  name: "scheduler-general-checkboxes",
  props: {
    value: {
      type: Object,
      required: true
    },
    allowModal: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      checkboxData: {
        allowMultipleTimes: false,
        isActivityOptional: false,
        showDailySummary: false
      }
    };
  },
  methods: {
    checkboxDataChanged(property, value) {
      this.checkboxData[property] = value;
      if (!this.checkboxData.allowMultipleTimes) {
        this.checkboxData.showDailySummary = false;
      }
      this.$emit("input", this.checkboxData);
    }
  },
  created() {
    this.checkboxData = { ...this.value };
  }
};
</script>

<style scoped>
.view-screen {
  font-size: 10px;
  color: #4c8ce4;
  padding-left: 16px;
}
.modal-dialog {
  max-width: 1000px !important;
}
</style>
